export default __webpack_public_path__ + "static/media/make2.05412acc.png";